<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.adaugaNivel1')}} </h4>
        </div>
        <form class="add-user-form" id="add-level1">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group"
                         v-for="input_field in input_fields.column_1"
                         :key="input_field.id">
                        <input type="text" class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :data-vv-as="input_field.labelName"
                               v-bind:name="input_field.inputName"
                               v-bind:id="input_field.inputName">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                            <i v-bind:class="input_field.icon"></i>
                        </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                    <div class="single-vselect">
                        <h4>{{$t('placeholder.punereInFunctiune')}}</h4>
                        <v-select v-model="pif" label="label" :options="pifs"></v-select>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_2" :key="input_field.id">
                        <input type="text"
                               class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :data-vv-as="input_field.labelName"
                               :name="input_field.inputName"
                               :id="input_field.inputName">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                                <i v-bind:class="input_field.icon"></i>
                            </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="save-contact-buttons">
                    <button @click.prevent='addLevel()' :disabled="this.$store.state.loading">
                        <i class="fas fa-check"></i>
                        {{$t('placeholder.salveaza')}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import Level1Service from '../../api-services/nivel1.service.js'

export default {
  name: 'addcategories',
  data () {
    return {
      level1: null,
      pif: null,
      input_fields: {
        column_1: [
          {
            inputName: 'ord',
            labelName: this.$t('placeholder.ord'),
            inputValue: (this.level1) ? this.level1.ord : null,
            icon: 'fas fa-sort-numeric-up',
            validationRules: 'alpha_num'
          },
          {
            inputName: 'name',
            labelName: this.$t('placeholder.denumire'),
            inputValue: (this.level1) ? this.level1.name : null,
            icon: 'fas fa-file-signature'
          }
        ],
        column_2: [
          {
            inputName: 'discount',
            labelName: this.$t('placeholder.discount'),
            inputValue: (this.level1) ? this.level1.discount : null,
            icon: 'fas fa-money-bill-wave info-tool',
            validationRules: 'alpha_num'
          },
          {
            inputName: 'addition_min',
            labelName: this.$t('placeholder.addition_min'),
            icon: 'fas fa-percentage info-tool',
            validationRules: 'alpha_num'
          },
          {
            inputName: 'addition_distribution',
            labelName: this.$t('placeholder.addition_distribution'),
            icon: 'fas fa-percentage info-tool',
            validationRules: 'alpha_num'
          },
          {
            inputName: 'addition_partner',
            labelName: this.$t('placeholder.addition_partner'),
            icon: 'fas fa-percentage info-tool',
            validationRules: 'alpha_num'
          },
          {
            inputName: 'addition_retail',
            labelName: this.$t('placeholder.addition_retail'),
            icon: 'fas fa-percentage info-tool',
            validationRules: 'alpha_num'
          }
        ]
      }
    }
  },
  methods: {
    addLevel () {
      if (!this.pif) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.selecteazaPif'),
          'animation-type': 'css'
        })
      }
      this.$store.dispatch('showLoading')
      // this.adjustLoadingContainer()
      let formData = new FormData(document.getElementById('add-level1'))
      if (this.pif.id) {
        formData.append('pif', this.pif.inputValue)
      }
      Level1Service.create(formData)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          if (response.status === 201) {
            this.$notify({
              group: 'succes',
              type: 'success',
              // title: 'Added',
              text: this.$t('success.nivel1Adaugat'),
              'animation-type': 'css'
            })
            // var frm = document.getElementById('test-id')
            // alert(frm.offsetTop)
            window.scrollTo(0, 0)
            this.$router.push({ name: 'categories' })
          }
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: this.$t('errors.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    }
  },
  computed: {
    pifs () {
      return [
        {
          'id': 1,
          'inputValue': 0,
          'label': this.$t('placeholder.nuNecesitaPif'),
          'inputName': 'PIF'
        },
        {
          'id': 2,
          'inputValue': 1,
          'label': this.$t('placeholder.necesitaPif'),
          'inputName': 'PIF'
        }
      ]
    }
  },
  created () {
    this.$store.dispatch('hideLoading')
    this.pif = this.pifs[0]
  }
}
</script>
